import { Link, LinkProps } from "react-router-dom";

export default function SectionSubhHeading(
  props: LinkProps
): React.ReactElement {
  const { children, ...rest } = props;

  return (
    <Link data-testid="section-subheading-component" {...rest}>
      {children}
    </Link>
  );
}
